import { DetailedHTMLProps, ForwardedRef, HTMLAttributes, forwardRef } from 'react';

interface EventBlockerProps extends DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
    stopPropagation?: boolean;
    preventDefault?: boolean;
    ref?: ForwardedRef<HTMLDivElement>;
}

const EventBlocker = forwardRef<HTMLDivElement, EventBlockerProps>((props, ref) => {
    const { stopPropagation = false, preventDefault = false, children, onClick, ...rest } = props;

    const handleClick = (e: any) => {
        if (preventDefault) {
            e.preventDefault();
        }

        if (stopPropagation) {
            e.stopPropagation();
        }

        onClick?.(e);
    };

    return (
        <div {...rest} ref={ref} onClick={handleClick}>
            {children}
        </div>
    );
});

export default EventBlocker;
